import { isValid, parse } from "date-fns";

import { AudiometerConfiguration } from "services/types/audiometer-configuration.type";

/**
 * The calibration date a piece of equipment reports, as a local-midnight Date.
 *
 * `parse` (rather than `new Date(s)`) keeps a "yyyy-MM-dd" string on the calendar day it names,
 * which is what `formatReportInput` writes back out — a UTC-based parse would shift the day for
 * every clinic west of Greenwich.
 *
 * The `isValid` check is load-bearing, not defensive. `parse` returns an **Invalid Date** for
 * anything that is not exactly "yyyy-MM-dd" (an ISO datetime, say), and an Invalid Date is both
 * truthy and `instanceof Date` — so it passes every guard a caller would think to write, reaches
 * `handleReportAttribute`, and makes `format()` throw `RangeError: Invalid time value`. On the
 * heal path that throw happens synchronously inside a `useEffect` and takes the report page down.
 */
export const calibrationDateFromConfig = (
  configuration?: AudiometerConfiguration | null
): Date | null => {
  if (!configuration?.calibration_date) return null;

  const parsed = parse(configuration.calibration_date, "yyyy-MM-dd", new Date());

  return isValid(parsed) ? parsed : null;
};
